import React from 'react'
import { useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import queryString from 'query-string'

import sharedAccountsApi from 'api/sharedAccountsApi';
const { anonymousDeny } = sharedAccountsApi;


class DenyComponentInner extends React.Component {

    state = {
        queryValues: queryString.parse(this.props.location.search),
        currentState: "pending",
        message: '',
        heading: ''
    }

    componentDidMount = () => {
        var { queryValues } = this.state;

        if(queryValues != null && queryValues.userId && queryValues.submittedDate) {
            anonymousDeny(queryValues.userId, queryValues.submittedDate)
            .then(response => {
                this.setState( {
                    currentState: "success",
                    heading: "Thank you!",
                    message: "The denial was processed successfully."
                });
            })
            .catch(error => {
                var heading = "Request Failed";
                var message = `There was an issue processing the denial request.  
                Please try again later or contact MktServ@honcompany.com for assistance. `;

                var errorMessage = error && error.response && error.response.data ? 
                    error.response.data.ExceptionMessage : 
                    null;

                if(errorMessage && errorMessage.includes("denied")) {
                    message = errorMessage;
                }

                this.setState( {
                    currentState: "error",
                    heading: heading,
                    message: message
                });
            });
        } else {
            this.setState( {
                currentState: "error",
                heading: "Share of Account Not Found",
                message: `The Share of Accounts submission associated with your request could not be found.
                    Please contact MktServ@honcompany.com for assistance. `
            });
        }
    }

    render = () => {
        const { heading, message } = this.state;
        
        return (
            <React.Fragment>
                <Typography component="h1" variant="h4" align="center">
                    { heading }
                </Typography>

                <br />

                <Typography component="p" align="left">
                    { message }
                    <p> <a href="/home">BACK</a> </p>
                </Typography>

                <br />
            </React.Fragment>        
        );
    }
}


export default function DenyComponent() {
  const location = useLocation();
  return <DenyComponentInner location={location} />;
}